// Settings mutations
/* eslint-disable */
import types from '../../types';

export default {
  [types.STORE_ADMIN_SETTINGS]: (state, payload) => {
    state.adminSettings = payload;
  },
  [types.STORE_PAYERS]: (state, payload) => {
    state.payers = payload;
  },
  [types.STORE_PAYER_CARRIERS]: (state, payload) => {
    state.payerCarriers = payload;
  },
  [types.CLEAR_PAYER_CARRIERS]: (state, payload) => {
    state.payerCarriers = {
      items: [],
      count: '',
      entity: {}
    };
  },
  [types.STORE_SENDERS]: (state, payload) => {
    state.senders = payload;
  },
  [types.STORE_PRINTERS]: (state, payload) => {
    state.printers = payload;
  },
  [types.STORE_PACKAGES]: (state, payload) => {
    state.packages = payload;
  },
  [types.STORE_USERS]: (state, payload) => {
    state.users = payload;
  },
  [types.STORE_TMP_USER]: (state, payload) => {
    state.user = payload; // Related with get_stored_user getter
  },
  [types.STORE_USER_PERMISSIONS]: (state, payload) => {
    state.userPermissions = payload.map((permission) => {
      if(permission.acl_route_group == 'connect/shop') {
        return {
          acl_route_group: 'connect/shop',
          edit: false,
          view: false,
        }
      } else {
        return permission;
      }
    });
  },
  [types.STORE_NEWS]: (state, payload) => {
    state.news = payload;
  },
  [types.STORE_SMTP]: (state, payload) => {
    state.smtps = payload;
    state.smtps_available = payload.smtps_available;
  },
  [types.STORE_ALL_SMTPS]: (state, payload) => {
    state.allSmtps = payload;
  },
  [types.STORE_SYSTEM]: (state, payload) => {
    state.systems = payload;
  },
  [types.STORE_NOTIFICATIONS]: (state, payload) => {
    state.notifications = payload;
  },
  [types.STORE_NOTIFICATION]: (state, payload) => {
    state.notification = payload;
  },
  [types.STORE_AUTOMATIONS]: (state, payload) => {
    state.automations = payload;
  },
  [types.STORE_AUTOMATION_ACTIONS]: (state, payload) => {
    state.automationActions = payload;
  },
  [types.STORE_AUTOMATION]: (state, payload) => {
    state.automation = payload;
  },
  [types.CLEAR_AUTOMATION]: (state, payload) => {
    state.automation = {
      items: {},
      entity: {}
    };
  },
  [types.CLEAR_AUTOMATION_ACTIONS]: (state, payload) => {
    state.automationActions = {
      items: [],
      count: '',
      entity: {}
    };
  },
  [types.STORE_TEMPLATES]: (state, payload) => {
    state.templates = payload;
  },
  [types.STORE_UPLOAD_PROGRESS]: (state, payload) => {
    state.uploadProgress = payload;
  },
  [types.STORE_OPTIONS_FOR_SELECTS_PREFERENCES]: (state, payload) => {
    state.label_formats = payload.label_formats;
    state.document_printers = payload.document_printers;
    state.label_printers = payload.label_printers;
    state.shippers = payload.shippers;
    state.goods_types = payload.goods_types;
    state.return_waybill_action_types = payload.return_waybill_action_types;
    state.packages_available = payload.packages_available;
  },
  [types.STORE_CARRIER_ACCOUNTS]: (state, payload) => {
    state.carrierAccounts = payload;
  },
  [types.STORE_CARRIER_ACCOUNT]: (state, payload) => {
    state.carrierAccount = payload;
  },
  [types.STORE_SHIPPING_AGENTS]: (state, payload) => {
    state.shippingAgents = payload;
  },
  [types.STORE_COMPANY_AVAILABLE_SHIPPING_AGENTS]: (state, payload) => {
    state.companyAvailableShippingAgents = payload;
  },
  [types.STORE_INTEGRATION_BY_CARRIER]: (state, payload) => {
    state.integrationsByCarrier = payload;
  },
  [types.STORE_INTEGRATION_PARAMS]: (state, payload) => {
    state.integrationParams.login = payload.login_params;
    state.integrationParams.barcode = payload.barcode_params;
  },
  [types.CLEAR_INTEGRATION_PARAMS]: (state) => {
    state.integrationParams.login = {};
    state.integrationParams.barcode = {};
  },
  [types.STORE_CARRIER_ACCOUNT_PRODUCTS]: (state, payload) => {
    state.carrierAccountProducts = payload.items;
    state.carrierAccountProduct  = payload.items;
  },
  [types.STORE_CARRIER_ACCOUNT_PRODUCT_BY_ID]: (state, payload) => {
    state.carrierAccountProduct = payload.items;
  },
  [types.STORE_ACCOUNT_CONSIGNORS]: (state, payload) => {
    state.shippers = payload.items;
  },
  [types.STORE_ACCOUNT_DANSKE_CODES]: (state, payload) => {
    state.accountDanskeCodes = payload;
  },
  [types.STORE_FTP_SETTINGS]: (state, payload) => {
    state.ftpSettings = payload;
  },
  [types.STORE_ALL_PACKAGING_OPTIONS]: (state, payload) => {
    state.allPackagingOptions = payload;
  },
};
